/* import __COLOCATED_TEMPLATE__ from './watch-get-the-most-messenger-video.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();